import React, { useEffect, useState } from 'react';
import styles from '../allEnquiresTab/specificationsTab.module.css';
import { Download, Filter } from '../../../../Svg';
import { Menu, MenuItem, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import CatPagination from '../../../../Website/utils/Pagination';
import { getAllPoOrderThunk, getCartOrdersThunk, setPoOrderPage } from '../../../../Website/redux/poorderSlice';
import { useDispatch, useSelector } from 'react-redux';
import ExcessOrderTable from './ExcessOrderTable';
import { exporteduploadedExcessStockThunk, geAlluploadedExcessStockThunk, setuploadedExcessStockPage } from '../../../../Website/redux/excessSlice';
import { exportDataExcel, formateDate } from '../../../../Website/utils/utils';

const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontSize: '014px',
  color: '#667085',
  backgroundColor: '#F0F1F3',
  fontSize: '14px',
  borderRadius: "4px",
  height: "40px",
  fontFamily: `'Public Sans', sans-serif`,
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
}));

const ExcessStockTab = ({ attributes, additionalResources }) => {
  const [activeTab, setActiveTab] = useState('Excess stock');
  const tabs = ['Excess stock'];
  const dispatch = useDispatch()
  const { uploadedExcessData, loading } = useSelector((state) => state.excess)
  const orders = uploadedExcessData?.data || []
  const page = uploadedExcessData?.page

  const [limit, setLimit] = useState(25)


  const data = orders?.data
  const totalPages = orders?.totalPages
  const totalItems = orders?.totalItems
  const itemsPerPage = orders?.limit
  const orderType = orders?.orderType
  const [status, setStatus] = useState('')
  const [exportLoading, setExportLoading] = useState(false)

  // calculate start & end of items -------------------
  const start = (page - 1) * limit + 1;
  const end =
    totalPages === page
      ? totalItems
      : (page - 1) * limit + limit;

  const [anchorEl, setAnchorEl] = useState(null);


  const handleClose = (status) => {
    if (status) {
      setStatus(status)

    }
    setAnchorEl(null);
  };

  useEffect(() => {
    dispatch(geAlluploadedExcessStockThunk(`?page=${page}&limit=${limit}&status=${status}`))

  }, [page, limit, status])

  console.log(data);

  const exportbomenq = async () => {
    setExportLoading(true)
    const status = await dispatch(exporteduploadedExcessStockThunk(`?limit=${1000000000000000}`))
    setExportLoading(false)
    console.log(status);

    if (status?.payload?.success === true) {

      const exportOrderData = status?.payload?.data
      const exportdata = exportOrderData?.map((item) => ({
        'id': item?._id || '-',
        'createdBy': item?.user?.fullName,
        'products': item?.partList?.length + 'products',
        'Status': item?.status || '-',
        'CreatedAt': formateDate(item?.createdAt),
      }))
      console.log("expo", exportdata);

      exportDataExcel(exportdata, "excessstock")
    }
  }

  return (
    <>
      <div className={styles.profilebodyContainer}>
        <div className={styles.profileheader}>
          <h2>Excess Inventory</h2>

          <div className={styles.displayFlex} >
            {/* <div>
              <ActionButton
                onClick={handleClick}
                sx={{
                  color: '#667085',
                  border: '1px solid #E0E2E7',
                  background: '#fff',
                  borderRadius: '8px',
                }}
              >
                <Filter /> Filters
              </ActionButton>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': 'status-button',
                }}
              >
                <MenuItem onClick={() => handleClose('ACTIVE')}
                  sx={{
                    borderBottom: '1px solid #E6E1E5',
                    fontSize: '14px',
                    color: '#667085',
                  }}>Active</MenuItem>
                <MenuItem onClick={() => handleClose('INACTIVE')}
                  sx={{
                    fontSize: '14px',
                    color: '#667085',
                  }}>Inactive</MenuItem>
              </Menu>
            </div> */}
            <button className={styles.submitBtn} onClick={exportbomenq} disabled={exportLoading}><Download /> {exportLoading ? "please wait..." : "Download"}</button>
          </div>
        </div>
        <div className={styles.speccontainer}>
          <div className={styles.spectabs}>
            {tabs.map((tab) => (
              <button
                key={tab}
                className={`${styles.spectabButton}  ${activeTab === tab ? styles.active : ''}`}
                style={{ width: '100%' }}
                onClick={() => setActiveTab(tab)}
              >
                Excess stock
              </button>
            ))}
          </div>
          {loading ?
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 10 }}>
              <img src="/assets/__Iphone-spinner-1.gif" alt="" style={{ width: 35, height: 35 }} />
            </div>
            :
            <>
              {data?.length > 0 ? (
                <ExcessOrderTable
                  data={data}
                  activeTab={activeTab}
                  loading={loading} />

              ) : (
                <div style={{ padding: 10, justifyContent: 'center', alignItems: 'center', display: 'flex' }}>No Order found</div>
              )}
            </>
          }
        </div>
        {(!loading && data?.length > 0) && (
          <CatPagination
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            start={start}
            end={end}
            page={page}
            setPage={setuploadedExcessStockPage}
          />
        )}
      </div>
    </>
  );
};

export default ExcessStockTab;
